import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Subject} from 'rxjs';
import {ResponseModel} from "@shared/models/response.model";
import {RestaurantModel} from '@shared/models/restaurant.model';
import {TableModel} from '@shared/models/table.model';
import { BranchModel } from '@shared/models/branch.model';
import { QrcodeModel } from '@shared/models/qrcode.model';
@Injectable({providedIn: 'root'})
export class TableService {
  private update = new Subject<string>();
  constructor(private http: HttpClient) {
  }

  private getFallbackIds() {
    const restaurant: RestaurantModel = JSON.parse(localStorage.getItem('restaurant'));
    const branch: BranchModel = JSON.parse(localStorage.getItem('branch'));
    return { restaurantId: restaurant?.id, branchId: branch?.id };
  }

  getAll(page = 0,
         perPage = 5,
         sort: string | null = null,
         filterKeyword: string | null = null,
         role: string | null = null,
         restaurantId?: string,
         branchId?: string
  ) {
    let params = new HttpParams()
      .set('page', page)
      .set('per_page', perPage);
    if (sort !== null) {
      params = params.set('sort', sort);
    }
    if (role !== null) {
      params = params.set('filter[role]', role);
    }


    if (filterKeyword !== null) {
      params = params.set('filter[status]', filterKeyword);
    }
    const ids = this.getFallbackIds();
    const restId = restaurantId || ids.restaurantId;
    const brId = branchId || ids.branchId;
    return this.http.get<ResponseModel<TableModel[]>>(`restaurants/${restId}/branches/${brId}/restaurant-tables`, {params});
  }

  addTable(member: object, restaurantId?: string, branchId?: string) {
    const ids = this.getFallbackIds();
    const restId = restaurantId || ids.restaurantId;
    const brId = branchId || ids.branchId;
    return this.http.post<ResponseModel<TableModel>>(`restaurants/${restId}/branches/${brId}/restaurant-tables`, member);
  }

  getTableByID(id: string, restaurantId?: string, branchId?: string) {
    const ids = this.getFallbackIds();
    const restId = restaurantId || ids.restaurantId;
    const brId = branchId || ids.branchId;
    return this.http.get<ResponseModel<TableModel>>(`restaurants/${restId}/branches/${brId}/restaurant-tables/${id}`);
  }

  editTable(id: string, member: object, restaurantId?: string, branchId?: string) {
    const ids = this.getFallbackIds();
    const restId = restaurantId || ids.restaurantId;
    const brId = branchId || ids.branchId;
    return this.http.post<ResponseModel<TableModel>>(`restaurants/${restId}/branches/${brId}/restaurant-tables/${id}?_method=PUT`, member);
  }

  deleteTable(id: string, restaurantId?: string, branchId?: string) {
    const ids = this.getFallbackIds();
    const restId = restaurantId || ids.restaurantId;
    const brId = branchId || ids.branchId;
    return this.http.delete(`restaurants/${restId}/branches/${brId}/restaurant-tables/${id}`);
  }

  sendUpdate(message: string) {
    this.update.next(message);
  }

  getUpdate() {
    return this.update.asObservable();
  }

  generateQR(qr: object, id:string, restaurantId?: string, branchId?: string) {
    const ids = this.getFallbackIds();
    const restId = restaurantId || ids.restaurantId;
    const brId = branchId || ids.branchId;
    return this.http.post<ResponseModel<QrcodeModel>>(`restaurants/${restId}/branches/${brId}/restaurant-tables/${id}/qr`, qr);
  }

  updateStatusTableToLocked(tableId: string, restaurantId?: string, branchId?: string) {
    const ids = this.getFallbackIds();
    const restId = restaurantId || ids.restaurantId;
    const brId = branchId || ids.branchId;
    return this.http.post(
      `restaurants/${restId}/branches/${brId}/restaurant-tables/${tableId}/mark-status-locked?_method=PUT`,
      null
    );
  }
}
